import React from 'react'
import { DialogOverlay, Bleed, Separator, LayoutBand, useContainerWidth, colors } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import Streaks from './Streaks'

export default function StreaksOverlay({ overlay, streakCount, endOfStreak, totalActivities, isCurrent }) {
  const { t } = useTranslation()
  const atWidth = useContainerWidth()
  return (
    <DialogOverlay {...overlay} title={t('streaks.title', 'Weekly Streaks')}>
      <Bleed top bottom>
        <LayoutBand
          css={css`
            background: linear-gradient(180deg, ${colors.yellow10} 58.57%, ${colors.yellow05} 100%);
            min-height: ${atWidth({ default: `calc(100vh - 64px)`, md: '100%' })};
          `}
        >
          <Streaks
            streakCount={streakCount}
            endOfStreak={endOfStreak}
            totalActivities={totalActivities}
            isCurrent={isCurrent}
          />
          <Separator size="md" />
        </LayoutBand>
      </Bleed>
    </DialogOverlay>
  )
}
